import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import useTranslation from '@/hooks/useTranslation';

interface ConfirmReinviteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  email: string;
  isLoading?: boolean;
}

export function ReinviteToOrgModal({
  isOpen,
  onClose,
  onConfirm,
  email,
  isLoading = false,
}: ConfirmReinviteModalProps) {
  const { lang } = useTranslation();

  return (
    <AlertDialog open={isOpen}>
      <AlertDialogContent className="sm:max-w-[425px]">
        <AlertDialogHeader>
          <AlertDialogTitle>{lang.get('msg.confirmReinviteTitle')}</AlertDialogTitle>
          <AlertDialogDescription className="text-dark-text">
            {lang.get('msg.confirmReinviteDescriptionPrefix')}
            <strong>{email}</strong>.
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter className="mt-5">
          <AlertDialogCancel onClick={onClose} disabled={isLoading}>
            {lang.get('msg.cancel')}
          </AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm} disabled={isLoading}>
            {lang.get('msg.confirm')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
